import Loadable from 'react-loadable';

export const PartnersListContainer = Loadable({
  loader: () => import('./PartnersList'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/PartnersList/index.ts